<template>
	<div class="bg_content">
		<div class="device_head">
			<span style="color: #b2b2b2">门禁管理 /</span>
			<span style="color: #5c5c5c"> 通行记录</span>
		</div>
		<div class="content_body">
			<el-card shadow="never" style="height: 80px;">
				<el-form :inline="true" class="demo-form-inline">
					<el-form-item>
						<el-input placeholder="设备名称、SN序列号" v-model="searchQuery.deviceSn" clearable></el-input>
					</el-form-item>
					<el-form-item>
						<el-select placeholder="请选择状态" v-model="searchQuery.status" clearable>
							<el-option v-for="(item,index) in statusList" :key="index" :value="item.id"
								:label="item.name"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-date-picker v-model="timerange"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            type="daterange" :clearable="false"
							:picker-options="pickerOptions" range-separator="至" start-placeholder="开始日期"
							end-placeholder="结束日期">
						</el-date-picker>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
					</el-form-item>
				</el-form>
			</el-card>
			<el-card class="card_table" shadow="never">
				<el-table :data="tableData" :header-cell-style="{background: '#F5F6FA',color: '#5C5C5C',}" height="580">
					<template slot="empty">
						<div>
							<img src="@/assets/nodata.png" class="nodata" />
							<div class="nodata_text">无数据</div>
						</div>
					</template>
					<el-table-column label="姓名" prop="">
						<template slot-scope="scope">
							{{scope?.row?.user?.name || '- -'}}
						</template>
					</el-table-column>
          <el-table-column label="员工工号" prop="">
            <template slot-scope="scope">
              {{scope?.row?.user?.jobNumber || '- -'}}
            </template>
          </el-table-column>
					<el-table-column label="设备名称" prop="">
						<template slot-scope="scope">
							{{scope?.row?.device?.name || '- -'}}
						</template>
					</el-table-column>
					<el-table-column label="SN序列号" prop="deviceSn">
            <template slot-scope="scope">
              {{scope?.row?.device?.sn || '- -'}}
            </template>
          </el-table-column>
          <el-table-column label="认证方式" prop="modeType">
            <template slot-scope="scope">
              {{ handleModeTypeText(scope.row.modeType) }}
            </template>
          </el-table-column>
					<el-table-column label="通行结果" prop="status">
						<template slot-scope="scope">
							<div v-if="scope.row.status === 1" class="table_scope_t">正常</div>
							<span v-else-if="scope.row.status === 2" class="table_scope_i">非允许时间段</span>
							<span v-else>- -</span>
						</template>
					</el-table-column>
          <el-table-column label="方向" prop="direction">
            <template slot-scope="scope">
              <div v-if="(scope?.row?.device?.equipmentUsageType === 2 || scope?.row?.device?.equipmentUsageType === 3) && scope?.row?.device?.direction === 1" class="table_scope_t">进</div>
              <span v-else-if="(scope?.row?.device?.equipmentUsageType === 2 || scope?.row?.device?.equipmentUsageType === 3) && scope?.row?.device?.direction === 2" class="table_scope_i">出</span>
              <span v-else>- -</span>
            </template>
          </el-table-column>
					<el-table-column label="通行时间" prop="passTime" width="190"></el-table-column>
					<!-- <el-table-column label="操作" width="200">
						<template slot-scope="scope">
							<el-link type="primary" style="margin-right: 25px;">查看</el-link>
						</template>
					</el-table-column> -->
				</el-table>
				<el-pagination v-model:current-page="searchQuery.pageNum" :page-size="searchQuery.pageSize"
					layout="total, ->, prev, pager, next" :total="tableTotal" @current-change="handleCurrentChange" />
			</el-card>
		</div>

		<company-footer-info />
	</div>
</template>

<script>
	import CompanyFooterInfo from "@/components/companyFooterInfo.vue";
	import dayjs from 'dayjs'
	import {
		PassageRecordLogApi
	} from "@/api/nexus/passageRecordLog"
	export default {
		components: {
			CompanyFooterInfo,
		},
		data() {
			return {
				pickerOptions: {
					disabledDate(time) {
						return time.getTime() > Date.now();
					},
					shortcuts: [{
						text: '最近一周',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近一个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近三个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
							picker.$emit('pick', [start, end]);
						}
					}]
				},
				timerange: [new Date(new Date().getTime() - 3600 * 1000 * 24 * 7), new Date()],
				//查询条件
				searchQuery: {
					deviceSn: '',
					status: '',
					pageSize: 20,
					pageNum: 1,
				},
				//表格数据
				tableData: [],
				tableTotal: 0,
				//1-正常，2-非法，3-非允许时间段
				statusList: [{
						id: 1,
						name: '正常'
					},
					{
						id: 2,
						name: '非允许时间段'
					},
				]
			}
		},
		methods: {
      handleModeTypeText(modeType){
        if(modeType){
            return modeType?.split('+')?.map(item => {
              switch (item) {
                case 'face':
                  return '人脸';
                case 'fp':
                  return '指纹';
                case 'palm':
                  return '掌静脉';
                case 'password':
                  return '密码';
                case 'card':
                  return '卡片';
                case 'qrcode':
                  return '二维码';
              }
            }).join('+') || '- -';
        }
        return '- -';
      },
			handleSearch() {
				this.searchQuery.pageNum = 1;
				this.getPassageRecordList();
			},
			//下一页
			handleCurrentChange(page) {
				this.searchQuery.pageNum = page;
				this.getPassageRecordList();
			},
			//获取数据
			async getPassageRecordList() {
				if (!(this.timerange && this.timerange.length >= 2)) {
					this.$message.error("请选择时间")
					return;
				}
				this.searchQuery.startTime = this.timerange[0] ? dayjs(this.timerange[0]).format('YYYY-MM-DD') : '';
				this.searchQuery.endTime = this.timerange[1] ? dayjs(this.timerange[1]).format('YYYY-MM-DD') : '';
				let {
					code,
					data
				} = await PassageRecordLogApi.page(this.searchQuery);
				if (code == 200) {
					this.tableData = data.list;
					this.tableTotal = data.total;
				}
			}
		},
		mounted() {
			this.getPassageRecordList();
		}
	}
</script>

<style scoped>
	.bg_content {
		width: 100%;
		padding: 16px 20px;
		background: #f4f7fc;
		height: 100%;
		display: flex;
		flex-direction: column;
		box-sizing: border-box;
	}

	.content_body {
		margin-top: 20px;
		height: 100%;
	}

	.table_scope_t {
		color: #409EFF;
	}

	.table_scope_i {
		color: #E6A23C;
	}

	.table_scope_r {
		color: #F56C6C;
	}

	.time_single {
		flex: 0 0 116px;
		/* 不伸缩，基准宽度 116px */
		width: 100px;
		/* 实际宽度 100px */
		height: 30px;
		line-height: 30px;
		text-align: center;
		font-size: 16px;
		color: #1a1a1a;
		background: #dee4ed;
		border-radius: 4px;
		margin-right: 8px;
		white-space: nowrap !important;
		overflow: hidden !important;
		text-overflow: ellipsis !important;

	}

	.card_table {
		height: calc(100% - 80px) !important;
	}
</style>